import React from 'react';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';

// for Student/Teacher items (they look the same shape)
function createUserData(item) {
  const u = item.user || {};
  return {
    // ids
    id: item.id,          // profile id (keep as-is for table/selection)
    user_id: u.id,        // <-- REAL user id (for /accounts/api/v1/users/:id/)

    // profile-level stuff
    image: item.image,

    // user-level fields
    address: u.address,
    isVerified: u.is_verified,
    is_active: u.is_active,
    email: u.email,
    national_id: u.national_id,
    birth_date: u.birth_date,
    mobile: u.mobile,
    last_name: u.last_name,
    first_name: u.first_name,
    full_name: [u.first_name, u.last_name].filter(Boolean).join(' '),
    created_date: u.created_date || item.created_date || item.profile?.created_date,

    // staff role only exists for staffs
    role: item.role ?? undefined,

    // deletion guard (present for students; safe to ignore for others)
    can_delete: item.can_delete,
  };
}



const userTypeFields = [
    { name: 'first_name', label: 'نام', type: 'text' },
    { name: 'last_name', label: 'نام خانوادگی', type: 'text' },
    { name: 'mobile', label: 'موبایل', type: 'text' },
    { name: 'birth_date', label: 'تاریخ تولد', type: 'date' },
    { name: 'national_id', label: 'شماره ملی', type: 'text', pattern: '^\\d{10}$', errorMessage: 'شماره ملی باید یک کد ۱۰ رقمی باشد.' },
    {
        name: 'email', label: 'ایمیل', type: 'email',
        keepLatinDigits: true,
        disabled: (formData) => formData?.isVerified ?? false,
        helperText: (formData) => formData?.isVerified ? 'ایمیل تایید شده است و قابل ویرایش نیست.' : ''
    },

    { name: 'address', label: 'نشانی', type: 'text' },
    // Active/inactive toggle — only meaningful when editing an existing account.
    { name: 'is_active', label: 'حساب فعال', type: 'switch', editOnly: true },
    {
        name: 'role',
        label: 'نقش',
        type: 'select',
        options: [
            { value: 'manager', label: 'مدیر' },  // Adjust based on actual roles
            { value: 'secretary', label: 'دفتردار' },
            { value: 'employee', label: 'کارمند' }
        ],
        condition: (formData) => !!formData?.role  // Use optional chaining
    },
];

export const teacherConfig = {
    title: "آموزگاران",
    addLabel: "افزودن آموزگار",
    icon: <SchoolOutlinedIcon fontSize="small" />,
    fetchUrl: "/accounts/api/v1/profile/teachers/",
    submitUrl: "/accounts/api/v1/profile/teachers/",
    rowHeaders: [
        "نام و نام خانوادگی",
        "موبایل",
        "ایمیل",
        "تاریخ ایجاد",
    ],
    displayFields: [
        'full_name',
        'mobile',
        'email',
        'created_date',
    ],
    detailFields: [
        { field: 'national_id', label: 'شماره ملی' },
        { field: 'birth_date', label: 'تاریخ تولد' },
        { field: 'address', label: 'نشانی' },
    ],
    fields: userTypeFields,
    createDataFunction: createUserData,
};

export const studentConfig = {
    title: "هنرجویان",
    addLabel: "افزودن هنرجو",
    icon: <GroupsOutlinedIcon fontSize="small" />,
    fetchUrl: "/accounts/api/v1/profile/students/",
    userSubmitUrl: (userId) => `/accounts/api/v1/users/${userId}/`,
    profileSubmitUrl: (profileId) => `/accounts/api/v1/profile/students/${profileId}/`,
    rowHeaders: [
        "نام و نام خانوادگی",
        "موبایل",
        "ایمیل",
        "تاریخ ایجاد",
    ],
    displayFields: [
        'full_name',
        'mobile',
        'email',
        'created_date',
    ],
    detailFields: [
        { field: 'national_id', label: 'شماره ملی' },
        { field: 'birth_date', label: 'تاریخ تولد' },
        { field: 'address', label: 'نشانی' },
    ],
    fields: userTypeFields,
    createDataFunction: createUserData,
};


export const staffConfig = {
    title: "کارمندان",
    addLabel: "افزودن کارمند",
    icon: <BadgeOutlinedIcon fontSize="small" />,
    fetchUrl: "/accounts/api/v1/profile/staffs/",
    submitUrl: "/accounts/api/v1/profile/staffs/",
    rowHeaders: [
        "نام و نام خانوادگی",
        "موبایل",
        "ایمیل",
        "نقش",
        "تاریخ ایجاد",
    ],
    displayFields: [
        'full_name',
        'mobile',
        'email',
        'role',
        'created_date',
    ],
    detailFields: [
        { field: 'national_id', label: 'شماره ملی' },
        { field: 'birth_date', label: 'تاریخ تولد' },
        { field: 'address', label: 'نشانی' },
    ],
    fields: userTypeFields,
    createDataFunction: createUserData,
};
